module.exports = __webpack_public_path__ + "media/images/athletes/1677-3905f34cac953916364036096a05a4e3.png";